'use client'

import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Cart } from '@shared/types/cart/Cart';
import { CartContext } from './Context';

export const CartProvider = ({ children }: { children: ReactNode }) => {
    const [cartDetails, setCartDetails] = useState<Cart | null>(null);

    return (
        <CartContext.Provider value={{ cartDetails, setCartDetails }}>
            {children}
        </CartContext.Provider>
    );
};